
import {
  CompoundDto,
  CompoundType,
  CreateCompoundDto,
  UpdateCompoundDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type CompoundsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
  isQualityControlConfigurable?: boolean
  isProductionStepConfigurable?: boolean
  type?: CompoundType
}

class CompoundService extends BaseCrudService<
  CompoundDto,
  CreateCompoundDto,
  UpdateCompoundDto,
  CompoundsFilters
> {
  constructor() {
    super('compound', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const compoundService = new CompoundService()
